import service from '@/utils/request';
// 新增公告
export function addNotice(param) {
    return service.request({
        method: 'POST',
        url: `/app/announcement/add`,
        data: param
    })
}

// 分页公告
export function getNoticeList(param) {
    return service.request({
        method: 'POST',
        url: `/app/announcement/announcementList`,
        data: param
    })
}

// 删除
export function delNotice(param) {
    return service.request({
        method: 'POST',
        url: `/app/announcement/del`,
        data: param
    })
}

// 获取公告详情
export function announcementById(param) {
    return service.request({
        method: 'POST',
        url: `/app/announcement/announcementById`,
        data: param
    })
}
// 公告上传图片
export function uploadImgs(param) {
    return service.request({
        method: 'POST',
        url: `/app/common/upload`,
        data: param
    })
}

// 公告上传图片
export function editNotice(param) {
    return service.request({
        method: 'POST',
        url: `/app/announcement/edit`,
        data: param
    })
}

// 中标公告
export function zhongbiaoAnnouncementList(param) {
    return service.request({
        method: 'POST',
        url: `/app/zhongbiaoAnnouncement/zhongbiaoAnnouncementList`,
        data: param
    })
}

// 获取中标公告详情
export function zhongbiaoAnnouncementById(param) {
    return service.request({
        method: 'POST',
        url: `/app/zhongbiaoAnnouncement/zhongbiaoAnnouncementById`,
        data: param
    })
}

// 未登录前获取中标公告详情
export function portalZhongbiaoAnnouncementById(param) {
    return service.request({
        method: 'POST',
        url: `/portal/app/zhongbiaoAnnouncement/zhongbiaoAnnouncementById`,
        data: param
    })
}


// 未登录前获取中标公告详情
export function zbggAnnouncementById(param) {
    return service.request({
        method: 'POST',
        url: `/portal/app/srmXjOrder/srmXjOrderById`,
        data: param
    })
}

// 获取采购寻源列表
export function xunyuanAnnouncementList(param) {
    return service.request({
        method: 'POST',
        url: `/app/xunyuanAnnouncement/xunyuanAnnouncementList`,
        data: param
    })
}

// 获取协议富文本
export function xieyilist(param) {
    return service.request({
        method: 'POST',
        url: `/app/xieyi/list`,
        data: param
    })
}
//
export function addXieyi(param) {
    return service.request({
        method: 'POST',
        url: `/app/xieyi/add`,
        data: param
    })
}
export function editXieyi(param) {
    return service.request({
        method: 'POST',
        url: `/app/xieyi/edit`,
        data: param
    })
}

export function xunyuanAnnouncementById(param) {
    return service.request({
        method: 'POST',
        url: `/app/xunyuanAnnouncement/xunyuanAnnouncementById`,
        data: param
    })
}
















